import { MainContainer } from '../../layout/components/MainContainer';
import React, { useContext, useState } from 'react';
import { TableSandBox } from './components/TableSandbox';
import { SandboxContextSM } from '../../serviceContextManager/Sandbox/SandboxServiceManager';
export const SandboxScreen = ({}) => {
  const service = useContext(SandboxContextSM);
  const renderContent = () => {
    return (
      <div className="flex w-full h-full relative flex-row">
        <div className="flex grow h-full relative flex-col content-center items-center justify-center overflow-x-auto  p-4 ">
          <TableSandBox service={service} />
        </div>
      </div>
    );
  };

  return (
    <MainContainer
      openRightMenu={service.openRightMenu}
      setOpenRightMenu={service.setOpenRightMenu}
      loading={false}
      rightMenuContent={<></>}>
      {renderContent()}
    </MainContainer>
  );
};
